module.exports = __webpack_public_path__ + "53227b3f015e28d40e3150d38c52af60.png";